import type { VideoAvatarsOptions } from '@mfc/mfc-video-sdk'

export const VIDEO_CONTAINER_CLASSES = 'videoplayerjs video-stream-container '
export const VIDEO_FULL_ROUNDED_CONTAINER_CLASSES = 'full-rounded '
export const VIDEO_BOTTOM_ROUNDED_CONTAINER_CLASSES = 'bottom-rounded '

export const VIDEO_ELEVATED_CONTAINER_CLASSES = 'elevated '
export const VIDEO_ZOOMED_CONTAINER_CLASSES = 'zoom-video '
export const VIDEO_CONTAINER_PREFIX_ID = 'video-container-'
export const VIDEO_PLAYER_ID = 'video-{{ID}}'
export const VIDEO_CONTAINER_CLASS = 'videoplayerjs'
export const FULL_WINDOW_CLASS = 'vjs-full-window'
export const THEATER_MODE_CLASS = 'vjs-theater'

// the SDK's clip element, also set on the Model Browser's own clip players
// (VideoAvatarTile); clips are region-safe, so the age gate's video blur
// skips them (_app.tsx); the developer NSFW blur does not
export const VIDEO_AVATAR_CLIP_CLASS = 'mfcvs-video-avatar-clip'

// the age gate's call to action that Video.tsx puts in a model's player
// container; public/css/app.css keeps one per container
export const AGE_GATE_CTA_OVERLAY_CLASS = 'age-gate-video-cta'

// Room players, every viewer: the same values as www (misc.MfcJs
// MfcClientVideo.js) and mobile. The Acr switches apply once Player.setACR()
// is on, which videoPlayerReady turns on for an age-gated visitor (see
// decideACR).
export const VIDEO_AVATARS_OPTIONS: VideoAvatarsOptions = {
    preload: true,
    showInAcr: true,
    acrPlayback: 'once',
    showWhenOfflineInAcr: true,
    showWhenOffline: true,
}

// Grid tile previews (VideoType.ModelTile) of a model the worker lists with
// clips, which it does only for an age-gated visitor: the room's ACR pass,
// one run of the clips and then the blurred live feed. No preload and no
// offline switches: a tile only builds a player while the model is on cam.
export const TILE_VIDEO_AVATARS_OPTIONS: VideoAvatarsOptions = {
    showInAcr: true,
    acrPlayback: 'once',
}
